import React, { useEffect, useState } from "react";
import styles from "./menuCol.module.scss";
import { MdKeyboardArrowUp, MdKeyboardArrowDown } from "react-icons/md";

interface MenuColProps {
    item: any;
    showList: boolean;
    isMobile: boolean;
}

export const MenuCol: React.FC<MenuColProps> = ({
    item,
    showList,
    isMobile,
}) => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        setShow(showList);

        return () => {
            setShow(false);
        };
    }, [showList]);

    return (
        <div className={styles.footer__menu__col}>
            <ul className={styles.footer__menu__col__list}>
                <li className={styles.footer__menu__col__list__header}>
                    {isMobile ? (
                        <>
                            <div
                                className={
                                    styles.footer__menu__col__list__title
                                }
                                onClick={() => setShow(!show)}
                            >
                                {item.title}
                            </div>
                            <div
                                className={
                                    styles.footer__menu__col__list__arrow
                                }
                            >
                                {show ? (
                                    <MdKeyboardArrowUp
                                        onClick={() => setShow(false)}
                                    />
                                ) : (
                                    <MdKeyboardArrowDown
                                        onClick={() => setShow(true)}
                                    />
                                )}
                            </div>
                        </>
                    ) : (
                        <div className={styles.footer__menu__col__list__title}>
                            {item.title}
                        </div>
                    )}
                </li>

                {item.links.map((link, l) => (
                    <li
                        key={l}
                        className={
                            show
                                ? styles.footer__menu__col__list__item
                                : styles.footer__menu__col__list__item__off
                        }
                        onClick={() => (window.location.href = link.url)}
                        aria-hidden="true"
                    >
                        {link.title}
                    </li>
                ))}
            </ul>
        </div>
    );
};
